import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import FolderOpenIcon from '@atlaskit/icon/core/folder-open';

import type { AgentTrustReceiptActorIconKey } from './agentTrustReceiptModel.ts';

type AgentTrustReceiptActorIcon = typeof AiAgentIcon;

const actorIconByKey: Record<AgentTrustReceiptActorIconKey, AgentTrustReceiptActorIcon> = {
	'rovo-agent': AiAgentIcon,
	'space-organizer-agent': FolderOpenIcon,
	'dev-docs-agent': BookWithBookmarkIcon,
};

export const getAgentTrustReceiptActorIcon = (
	iconKey: AgentTrustReceiptActorIconKey,
): AgentTrustReceiptActorIcon => actorIconByKey[iconKey];
